var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ev10BWj3tCK1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 52 53",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "{`\n      #ev10BWj3tCK2 {\n        animation: ev10BWj3tCK2_s_do 1000ms linear 1 normal forwards;\n      }\n      @keyframes ev10BWj3tCK2_s_do {\n        0% { stroke-dashoffset: 134.14; }\n        50% { stroke-dashoffset: 0; }\n        100% { stroke-dashoffset: 0; }\n      }\n      #ev10BWj3tCK3 {\n        animation-name: ev10BWj3tCK3_s_do, ev10BWj3tCK3_s_da;\n        animation-duration: 1000ms;\n        animation-fill-mode: forwards;\n        animation-timing-function: linear;\n        animation-direction: normal;\n        animation-iteration-count: 1;\n      }\n      @keyframes ev10BWj3tCK3_s_do {\n        0% { stroke-dashoffset: 54.68; }\n        50% { stroke-dashoffset: 54.68; }\n        80% { stroke-dashoffset: 0; }\n        100% { stroke-dashoffset: 0; }\n      }\n      @keyframes ev10BWj3tCK3_s_da {\n        0% { stroke-dasharray: 54.68; }\n        50% { stroke-dasharray: 54.68; }\n        100% { stroke-dasharray: 54.68; }\n      }\n    `}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ev10BWj3tCK2",
    d: "M6.42062,28.2412C10.7899,23.6564,15.024,18.2315,18.591,12.9784c1.9087-2.8109,4.0827-5.42826,5.8928-8.27403.2551-.40104.7031-2.00124,1.3243-1.77307.9805.36014,2.0805,1.21791,2.8243,1.92866c2.1609,2.06466,4.8544,3.93413,7.4713,5.36554c2.0759,1.1354,3.7781,2.114,5.5617,3.6758.9756.8543,3.0345,1.7395,3.2801,3.0126.6847,3.5495-1.6451,7.9797-3.2254,11.0838-2.3222,4.5614-4.5728,9.1135-7.7414,13.1528-1.9656,2.5056-4.4584,4.3897-6.5274,6.7526-1.9058,2.1765-1.7692,1.9304-4.5007.8882-2.6903-1.0264-4.6092-2.5257-6.7918-4.4368-1.1362-.9949-2.8175-1.5841-4.1839-2.2411-1.0349-.4977-1.7293-1.7608-2.45738-2.6084-.76367-.889-1.62084-3.9522-2.7974-4.2056-1.15319-.2483-2.68119-1.1824-2.76941-2.5127-.07203-1.0863,6.69819-10.2268,1.52904-.9441",
    fill: "none",
    stroke: "#f55",
    strokeWidth: 1.66333,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDashoffset: 134.14,
    strokeDasharray: 134.14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "ev10BWj3tCK3",
    d: "M5.12012,34.0572c2.20371.1754,4.47356.7723,6.64148.8985.7205.0419,1.7901-.4304,2.4186-.2353c1.7018.5282,5.523-1.6641,7.2715-2.1674c1.9737-.5681,8.0041-.0128,7.7752-3.4648-.4303-6.489-.6943-13.0118-1.1228-19.47457-.081-1.22107-.7452-2.20126-.8191-3.31621-.2251-3.39411-2.7029-.24226-3.5647.74196",
    fill: "none",
    stroke: "#f55",
    strokeWidth: 1.66333,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDashoffset: 54.68,
    strokeDasharray: 54.68
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.cd3e6ef06dc7564fee2d9b19a9434428.svg";
export { ForwardRef as ReactComponent };